import React, { useCallback, useEffect } from "react";
import "./product-3d-config-tabs.scss";
import { Drawer, Spin, Tabs } from "antd";
import "antd/dist/antd.css";
import { CustomTab } from "./custom-tab/CustomTab";
import { PantsIcon } from "./icons/PantsIcon";
import { FabricIcon } from "./icons/FabricIcon";
import { ColorsIcon } from "./icons/ColorsIcon";
import { LazerIcon } from "./icons/LazerIcon";
import { DamageIcon } from "./icons/DamageIcon";
import { CustomDesignIcon } from "./icons/CustomDesignIcon";
import { StylingForm } from "./forms/StylingForm";
import { FabricForm } from "./forms/FabricForm";
import { ColorsForm } from "./forms/ColorsForm";
import { LazerForm } from "./forms/LazerForm";
import { DamageForm } from "./forms/DamageForm";
import { MyOwnDesignForm } from "./forms/MyOwnDesignForm";
import { OrderButton } from "./forms/buttons/OrderButton";
import { useDispatch, useSelector } from "react-redux";
import {
  createCustomizedProduct,
  orderCustomizedProduct,
} from "../../actions/order-actions/actions";
import order_sent from "../../img/order_sent.jpg";
import { history } from "../../index";
import "./forms/buttons/order-button-h.scss";
import BottomDrawer from "../BottomDrawer/BottomDrawer";
import { handleBottomDrawer } from "../../actions/actionCreators";
import OrderServices from "../../actions/order-actions/services";
import {
  CREATE_CUSTOMIZED_PRODUCT_FAIL,
  CREATE_CUSTOMIZED_PRODUCT_REQUEST,
  CREATE_CUSTOMIZED_PRODUCT_SUCCESS,
} from "../../actions/order-actions/types";
import { MyNotif } from "../NotifIcons/NotifIcons";
import { LoadingOutlined } from "@ant-design/icons";
import { useParams } from "react-router-dom";
import axios from "axios";

const { TabPane } = Tabs;

export type IProduct3dConfigTabsProps = {
  selectedProduct: any;
  // originalProduct: any;
};

const Product3dConfigTabs: React.FC<IProduct3dConfigTabsProps> = ({
  selectedProduct,
  // originalProduct,
}) => {
  const params = useParams<any>();
  console.log(params);
  const [activeTabKey, setActiveTabKey] = React.useState("1");
  const [notApproveIsVisible, setNotApproveIsVisible] = React.useState(false);
  const [width, setWidth] = React.useState(window.innerWidth);
  const [isLoading, setIsLoading] = React.useState(false);
  const [data, setData] = React.useState<any>({
    style: params.status === "edit" ? selectedProduct.style : "",
    style_details:
      params.status === "edit" ? selectedProduct.style_details : "",
    style_files: [],
    fabric: params.status === "edit" ? selectedProduct.fabric : "none",
    fabric_image: "",
    fabric_details:
      params.status === "edit" ? selectedProduct.fabric_details : "",
    fabric_files: [],
    color: params.status === "edit" ? selectedProduct.color : "",
    color_details:
      params.status === "edit" ? selectedProduct.color_details : "",
    color_files: [],
    // laser_images: "",
    laser_images_design: "",
    laser_images_drawing: "",
    laser_type_images: "",
    laser_details:
      params.status === "edit" ? selectedProduct.laser_details : "",
    damage_images: "",
    damage_details:
      params.status === "edit" ? selectedProduct.damage_details : "",
    damage_type_images: "",
    design_details:
      params.status === "edit" ? selectedProduct.design_details : "",
    design_images: "",
    design_type_images: [],
    feedback: params.status === "edit" ? selectedProduct.feedback : "",
    ordered: false,
    pantone_code_knit: "",
    name: selectedProduct && selectedProduct.name,

    tmp_laser_images_drawing_front:
      params.status === "edit"
        ? selectedProduct?.tmp_laser_images_drawing_front
          ? JSON.parse(
              JSON.parse(selectedProduct?.tmp_laser_images_drawing_front)
            )
          : []
        : [],
    tmp_laser_images_drawing_back:
      params.status === "edit"
        ? selectedProduct?.tmp_laser_images_drawing_back
          ? JSON.parse(
              JSON.parse(selectedProduct?.tmp_laser_images_drawing_back)
            )
          : []
        : [],

    tmp_laser_images_design_front:
      params.status === "edit"
        ? selectedProduct?.tmp_laser_images_design_front
          ? JSON.parse(
              JSON.parse(selectedProduct?.tmp_laser_images_design_front)
            )
          : []
        : [],
    tmp_laser_images_design_back:
      params.status === "edit"
        ? selectedProduct?.tmp_laser_images_design_back
          ? JSON.parse(
              JSON.parse(selectedProduct?.tmp_laser_images_design_back)
            )
          : []
        : [],

    tmp_design_front:
      params.status === "edit"
        ? selectedProduct?.tmp_design_front
          ? JSON.parse(JSON.parse(selectedProduct?.tmp_design_front))
          : []
        : [],
    tmp_design_back:
      params.status === "edit"
        ? selectedProduct?.tmp_design_back
          ? JSON.parse(JSON.parse(selectedProduct?.tmp_design_back))
          : []
        : [],

    tmp_damage_front:
      params.status === "edit"
        ? selectedProduct?.tmp_damage_front
          ? JSON.parse(JSON.parse(selectedProduct?.tmp_damage_front))
          : []
        : [],
    tmp_damage_back:
      params.status === "edit"
        ? selectedProduct?.tmp_damage_back
          ? JSON.parse(JSON.parse(selectedProduct?.tmp_damage_back))
          : []
        : [],
  });
  const [newDamageTypeImages, setNewDamageTypeImages] = React.useState<any>([]);

  const deletePositionFiles = (id: string, attribute: string) => {
    setData({
      ...data,
      [attribute]: data[attribute].filter((el: any) => el.id !== id),
    });
  };

  function createFile(section: any) {
    console.log(section.name);
    section?.files?.forEach(async (file: any) => {
      let response = await axios.get(
        process.env.REACT_APP_STORAGE_URL + file.file,
        { responseType: "blob" }
      );

      let metadata = {
        type: file.file.slice(-3) === "pdf" ? "application/pdf" : "image/jpeg",
      };
      const blob = new Blob([response.data]);
      let newFile = new File([blob], file.file, metadata);

      Object.defineProperties(newFile, {
        preview: {
          value: URL.createObjectURL(blob),
          writable: true,
        },
        name: {
          value: file.file,
          writable: true,
        },
        color: {
          value: file?.color,
          writable: true,
        },
      });
      setData((x: any) => {
        console.log({ sectionName: section.name, file: newFile });
        return {
          ...x,
          [section.name]: [...x[section.name], newFile],
        };
      });
    });
  }

  useEffect(() => {
    if (params.status === "edit") {
      let styleFiles = selectedProduct?.style_files
        ? JSON.parse(selectedProduct.style_files)
        : [];
      let fabricFiles = selectedProduct?.fabric_files
        ? JSON.parse(selectedProduct?.fabric_files)
        : [];
      let colorFiles = selectedProduct?.color_files
        ? JSON.parse(selectedProduct?.color_files)
        : [];
      let laserTypeFiles = selectedProduct?.laser_type_images
        ? JSON.parse(selectedProduct?.laser_type_images)
        : [];
      let damageTypeFiles = selectedProduct?.damage_type_images
        ? JSON.parse(selectedProduct?.damage_type_images)
        : [];
      let designTypeFiles = selectedProduct?.design_type_images
        ? JSON.parse(selectedProduct?.design_type_images)
        : [];

      [
        { files: styleFiles, name: "style_files" },
        { files: fabricFiles, name: "fabric_files" },
        { files: colorFiles, name: "color_files" },
        { files: Object.values(laserTypeFiles), name: "laser_type_images" },
        { files: Object.values(damageTypeFiles), name: "damage_type_images" },
        { files: Object.values(designTypeFiles), name: "design_type_images" },
      ].forEach((el: any) => {
        createFile(el);
      });
    }
  }, [params.productId, params.status]);

  const drawers = useSelector((state: any) => state.drawers);

  const dispatch = useDispatch();

  const mouseMoveFrontLazer = useCallback(
    (mousePosition: { x: number; y: number }) => {
      setData({
        ...data,
        tmp_laser_images_drawing_front: [
          ...data.tmp_laser_images_drawing_front,
          mousePosition,
        ],
      });
    },
    [data]
  );

  const mouseMoveBackLazer = useCallback(
    (mousePosition: { x: number; y: number }) => {
      setData({
        ...data,
        tmp_laser_images_drawing_back: [
          ...data.tmp_laser_images_drawing_back,
          mousePosition,
        ],
      });
    },
    [data]
  );

  const mouseClickFrontLazerDesign = useCallback(
    (mousePosition: { id: string; x: number; y: number; color: string }) => {
      setData({
        ...data,
        tmp_laser_images_design_front: [
          ...data.tmp_laser_images_design_front,
          mousePosition,
        ],
      });
    },
    [data]
  );

  const mouseClickBackLazerDesign = useCallback(
    (mousePosition: { id: string; x: number; y: number; color: string }) => {
      setData({
        ...data,
        tmp_laser_images_design_back: [
          ...data.tmp_laser_images_design_back,
          mousePosition,
        ],
      });
    },
    [data]
  );

  const mouseClickFrontDamage = useCallback(
    (mousePosition: { id: string; x: number; y: number; color: string }) => {
      setData({
        ...data,
        tmp_damage_front: [...data.tmp_damage_front, mousePosition],
      });
    },
    [data]
  );

  const mouseClickBackDamage = useCallback(
    (mousePosition: { id: string; x: number; y: number; color: string }) => {
      setData({
        ...data,
        tmp_damage_back: [...data.tmp_damage_back, mousePosition],
      });
    },
    [data]
  );

  const mouseClickFrontDesign = useCallback(
    (mousePosition: { id: string; x: number; y: number; color: string }) => {
      setData({
        ...data,
        tmp_design_front: [...data.tmp_design_front, mousePosition],
      });
    },
    [data]
  );

  const mouseClickBackDesign = useCallback(
    (mousePosition: { id: string; x: number; y: number; color: string }) => {
      setData({
        ...data,
        tmp_design_back: [...data.tmp_design_back, mousePosition],
      });
    },
    [data]
  );

  const handleImageTypes = (image: { file: any; color: string }) => {
    setData((x: any) => ({
      ...x,
      laser_type_images: [...x.laser_type_images, image],
    }));
  };

  const handleImageTypesDamage = (image: { file: any; color: string }) => {
    setData((x: any) => ({
      ...x,
      damage_type_images: [...x.damage_type_images, image],
    }));
  };

  const handleImageTypesDesign = (image: { file: any; color: string }) => {
    setData((prevState: any) => ({
      ...prevState,
      design_type_images: [...prevState.design_type_images, image],
    }));
  };

  React.useEffect(() => {
    const resize: any = window.addEventListener("resize", () => {
      setWidth(window.innerWidth);
    });
    return () => {
      window.removeEventListener("resize", resize);
    };
  }, [width]);

  useEffect(() => {
    setData({
      ...data,
      selectedProduct,
      // style_files: JSON.parse(JSON.parse(selectedProduct.style_files)),
    });
  }, [params]);

  // handle input values
  const handleChange = (e: any) => {
    setData({ ...data, [e.target.name]: e.target.value });
  };

  // handle type_images
  /* const handleImageTypes = (image: any, field: string) => {
    setData({ ...data, [field]: [...data[field], image] });
  }; */

  // delete type_images
  const deleteImageTypes = (color: string, field: string) => {
    setData({
      ...data,
      [field]: data[field].filter((el: any) => el.color !== color),
    });
  };
  // handle fabric image
  const handleFabricImage = (image: any, name: any) => {
    setData({ ...data, fabric_image: image, fabric: name });
  };

  // attach file
  const attachFile = (name: string, files: any) => {
    setData({ ...data, [name]: files });
  };

  // delete attached file
  const deleteFile = (name: string, file: any) => {
    setData({
      ...data,
      //@ts-ignore
      [name]: data[name].filter((el: any) => el.name !== file.name),
    });
  };

  // handle Color img
  const handleColorImg = (color: any) => {
    setData({ ...data, color: color });
  };

  const handleSceenShorts = (name: string, img: any) => {
    setData({ ...data, [name]: img });
  };
  const handleSceenShortsDamage = (name: string, img: any) => {
    setData({ ...data, [name]: img });
  };
  const handleSceenShortsTypeLazer = (name: string, img: any) => {
    setData({ ...data, [name]: img });
  };
  const handleSceenShortsDesign = (name: string, img: any) => {
    setData({ ...data, [name]: img });
  };

  const handleSubmit = async (e: any) => {
    e.preventDefault();
    let formData = new FormData();

    Object.keys(data)
      .filter((x: any) => !x.includes("files"))
      .map((el: any) => data[el] && formData.append(el, data[el]));

    /*    data.laser_images = [
      ...(data.laser_images ? data.laser_images : []),
      ...(data.laser_type_images ? data.laser_type_images : []),
    ]; */

    data.laser_images_design = [
      ...(data.laser_images_design ? data.laser_images_design : []),
      ...(data.laser_type_images
        ? data.laser_type_images.map((el: any) => el.file)
        : []),
    ];

    data.damage_images = [
      ...(data.damage_images ? data.damage_images : []),
      ...(data.damage_type_images
        ? data.damage_type_images.map((el: any) => el.file)
        : []),
    ];

    data.design_images = [
      ...(data.design_images ? data.design_images : []),
      ...(data.design_type_images
        ? data.design_type_images.map((el: any) => el.file)
        : []),
    ];

    if (data.laser_type_images.length) {
      for (let i = 0; i < data.laser_type_images.length; i++) {
        if (!data.laser_type_images[i].file) {
          continue;
        }
        formData.append(
          `laser_type_images[${i}][file]`,
          data.laser_type_images[i].file
        );
        formData.append(
          `laser_type_images[${i}][color]`,
          data.laser_type_images[i].color
        );
      }
    }

    if (data.damage_type_images.length) {
      for (let i = 0; i < data.damage_type_images.length; i++) {
        if (!data.damage_type_images[i].file) {
          continue;
        }
        formData.append(
          `damage_type_images[${i}][file]`,
          data.damage_type_images[i].file
        );
        formData.append(
          `damage_type_images[${i}][color]`,
          data.damage_type_images[i].color
        );
      }
    }

    if (data.design_type_images.length) {
      for (let i = 0; i < data.design_type_images.length; i++) {
        if (!data.design_type_images[i].file) {
          continue;
        }
        formData.append(
          `design_type_images[${i}][file]`,
          data.design_type_images[i].file
        );
        formData.append(
          `design_type_images[${i}][color]`,
          data.design_type_images[i].color
        );
      }
    }

    if (data.style_files.length) {
      for (let i = 0; i < data.style_files.length; i++) {
        formData.append(`style_files[${i}]`, data.style_files[i]);
      }
    }
    if (data.fabric_files.length) {
      for (let i = 0; i < data.fabric_files.length; i++) {
        formData.append(`fabric_files[${i}]`, data.fabric_files[i]);
      }
    }
    if (data.color_files.length) {
      for (let i = 0; i < data.color_files.length; i++) {
        formData.append(`color_files[${i}]`, data.color_files[i]);
      }
    }

    if (data.damage_images) {
      for (let i = 0; i < data.damage_images.length; i++) {
        formData.append(`damage_images[${i}]`, data.damage_images[i]);
      }
    }
    /*   if (data.laser_images) {
      for (let i = 0; i < data.laser_images.length; i++) {
        formData.append(`laser_images[${i}]`, data.laser_images[i]);
      }
    }
 */

    if (data.laser_images_design) {
      for (let i = 0; i < data.laser_images_design.length; i++) {
        formData.append(
          `laser_images_design[${i}]`,
          data.laser_images_design[i]
        );
      }
    }
    if (data.laser_images_drawing) {
      for (let i = 0; i < data.laser_images_drawing.length; i++) {
        formData.append(
          `laser_images_drawing[${i}]`,
          data.laser_images_drawing[i]
        );
      }
    }
    if (data.design_images) {
      for (let i = 0; i < data.design_images.length; i++) {
        formData.append(`design_images[${i}]`, data.design_images[i]);
      }
    }
    formData.append(
      "product_id",
      params.status === "new" ? selectedProduct.id : selectedProduct.product_id
    );
    // create a customized product and order it
    // dispatch(createCustomizedProduct(formData, true));
    // dispatch({
    // formData.append("product_id", selectedProduct.id);
    formData.append(
      "tmp_laser_images_drawing_front",
      JSON.stringify(data.tmp_laser_images_drawing_front)
    );
    formData.append(
      "tmp_laser_images_drawing_back",
      JSON.stringify(data.tmp_laser_images_drawing_back)
    );

    formData.append("tmp_damage_front", JSON.stringify(data.tmp_damage_front));
    formData.append("tmp_damage_back", JSON.stringify(data.tmp_damage_back));

    formData.append("tmp_design_front", JSON.stringify(data.tmp_design_front));
    formData.append("tmp_design_back", JSON.stringify(data.tmp_design_back));

    formData.append(
      "tmp_laser_images_design_front",
      JSON.stringify(data.tmp_laser_images_design_front)
    );
    formData.append(
      "tmp_laser_images_design_back",
      JSON.stringify(data.tmp_laser_images_design_back)
    );
    // create a customized product and order it
    //  dispatch(createCustomizedProduct(formData, true));
    dispatch({
      type: CREATE_CUSTOMIZED_PRODUCT_REQUEST,
    });
    setIsLoading(true);
    try {
      const response = await OrderServices.createCustomizedProduct(
        formData,
        params.status === "edit",
        params.status === "edit" ? selectedProduct.id : null
      );
      dispatch({
        type: CREATE_CUSTOMIZED_PRODUCT_SUCCESS,
        payload: response.data,
      });
      // await dispatch(orderCustomizedProduct(response.data.id));
      setIsLoading(false);
      setNotApproveIsVisible(true);
      setTimeout(() => {
        setNotApproveIsVisible(false);
      }, 2000);
    } catch (error: any) {
      // await dispatch({
      //   type: CREATE_CUSTOMIZED_PRODUCT_FAIL,
      //   payload: error.response,
      // });
      setIsLoading(false);
      MyNotif("Make at least one modification", "danger");
    }
  };

  return (
    <div className="product-3d-config-tabs">
      <div className="top-header ml-2">
        <div className="title mt-2">Product customization</div>
        {/* <div className="product-name">{selectedProduct.name}</div> */}
        <h4 className="product-name h4_medium mb-0 mt-2">
          {params.status === "new"
            ? selectedProduct?.code
            : selectedProduct?.original_product?.code}
        </h4>
        <h4 className="product-name" style={{ fontWeight: 400 }}>
          {params.status === "new"
            ? selectedProduct?.name
            : selectedProduct?.original_product?.name}
        </h4>
      </div>
      <form>
        <div>
          <Tabs
            tabPosition={"left"}
            activeKey={activeTabKey}
            onChange={(key) => setActiveTabKey(key)}
          >
            <TabPane
              tab={
                <CustomTab
                  name={width <= 575 ? "" : "Style"}
                  icon={<PantsIcon />}
                />
              }
              key="1"
            >
              <StylingForm
                {...{ setActiveTabKey }}
                handleChange={handleChange}
                attachFile={attachFile}
                deleteFile={deleteFile}
                globalData={data}
                selectedProduct={selectedProduct}
              />
            </TabPane>
            <TabPane
              tab={
                <CustomTab
                  name={width <= 575 ? "" : "FABRIC"}
                  icon={<FabricIcon />}
                />
              }
              key="2"
            >
              <FabricForm
                {...{ setActiveTabKey }}
                handleChange={handleChange}
                handleFabricImage={handleFabricImage}
                attachFile={attachFile}
                deleteFile={deleteFile}
                globalData={data}
              />
            </TabPane>
            <TabPane
              tab={
                <CustomTab
                  name={
                    params.status === "edit"
                      ? selectedProduct?.original_product?.fabric_type ===
                        "knit"
                        ? "COLOR"
                        : selectedProduct?.original_product?.fabric_type ===
                            "denim" && "BASE COLOR"
                      : selectedProduct?.fabric_type === "knit"
                      ? "COLOR"
                      : "BASE COLOR"
                  }
                  icon={<ColorsIcon />}
                />
              }
              key="3"
            >
              <ColorsForm
                {...{ setActiveTabKey }}
                handleChange={handleChange}
                handleColorImg={handleColorImg}
                attachFile={attachFile}
                deleteFile={deleteFile}
                globalData={data}
                isDenim={
                  params.status === "edit"
                    ? selectedProduct?.original_product?.fabric_type === "denim"
                    : selectedProduct?.fabric_type === "denim"
                }
              />
            </TabPane>
            <TabPane
              tab={
                <CustomTab
                  name={width <= 575 ? "" : "LASER INTENSITY"}
                  icon={<LazerIcon />}
                />
              }
              key="4"
            >
              <LazerForm
                handleSceenShorts={handleSceenShorts}
                handleSceenShortsTypeLazer={handleSceenShortsTypeLazer}
                handleChange={handleChange}
                handleImageTypes={handleImageTypes}
                deleteImageTypes={deleteImageTypes}
                globalData={data}
                mouseMoveFrontLazer={mouseMoveFrontLazer}
                mouseMoveBackLazer={mouseMoveBackLazer}
                mouseClickFrontLazerDesign={mouseClickFrontLazerDesign}
                mouseClickBackLazerDesign={mouseClickBackLazerDesign}
                deletePositionFiles={(id: string, attribute: string) =>
                  deletePositionFiles(id, attribute)
                }
              />
            </TabPane>
            <TabPane
              tab={
                <CustomTab
                  name={
                    params.status === "edit"
                      ? selectedProduct?.original_product?.fabric_type ===
                        "knit"
                        ? "Graphic "
                        : selectedProduct?.original_product?.fabric_type ===
                            "denim" && "DAMAGES"
                      : selectedProduct?.fabric_type === "knit"
                      ? "Graphic"
                      : "DAMAGES"
                  }
                  icon={<DamageIcon />}
                />
              }
              key="5"
            >
              <DamageForm
                handleSceenShortsDamage={handleSceenShortsDamage}
                handleChange={handleChange}
                handleImageTypes={handleImageTypesDamage}
                deleteImageTypes={deleteImageTypes}
                globalData={data}
                mouseClickFrontDamage={mouseClickFrontDamage}
                mouseClickBackDamage={mouseClickBackDamage}
                initialDesign={{
                  images: data.damage_type_images || [],
                  front: data.tmp_damage_front || [],
                  back: data.tmp_damage_back || [],
                }}
                deletePositionFiles={(id: string, attribute: string) =>
                  deletePositionFiles(id, attribute)
                }
              />
            </TabPane>
            {selectedProduct?.fabric_type !== "knit" && (
              <TabPane
                tab={
                  <CustomTab
                    name={width <= 575 ? "" : `ADD YOUR \r\n OWN DESIGN`}
                    icon={<CustomDesignIcon />}
                  />
                }
                key="6"
              >
                <MyOwnDesignForm
                  handleSceenShortsDesign={handleSceenShortsDesign}
                  handleChange={handleChange}
                  handleImageTypes={handleImageTypesDesign}
                  deleteImageTypes={deleteImageTypes}
                  globalData={data}
                  mouseClickFrontDesign={mouseClickFrontDesign}
                  mouseClickBackDesign={mouseClickBackDesign}
                  initialDesign={{
                    images: data?.design_type_images || [],
                    front: data?.tmp_design_front || [],
                    back: data?.tmp_design_back || [],
                  }}
                  deletePositionFiles={(id: string, attribute: string) =>
                    deletePositionFiles(id, attribute)
                  }
                />
              </TabPane>
            )}
          </Tabs>
        </div>
        <div className="btn-configurator-holder border-top">
          <button
            onClick={(e: any) => {
              e.preventDefault();
              history.back();
            }}
            className="order-btn-h mr-auto cancel_customization"
            style={{ fontSize: "1rem" }}
          >
            Cancel
          </button>
          <button
            className="order-btn-h"
            style={{ fontSize: "1rem" }}
            onClick={handleSubmit}
            // onClick={(e: any) => {
            //   // e.preventDefault();
            //   // dispatch(handleBottomDrawer());
            //   handleSubmit()
            // }}
          >
            {isLoading ? (
              <Spin
                indicator={
                  <LoadingOutlined
                    style={{ fontSize: 24, color: "white" }}
                    spin
                  />
                }
              />
            ) : (
              "Save"
            )}
          </button>
          {/* <button
            onClick={handleSubmit}
            className="order-btn-h"
            style={{ fontSize: "1rem" }}
          >
            {isLoading ? (
              <Spin
                indicator={
                  <LoadingOutlined
                    style={{ fontSize: 24, color: "white" }}
                    spin
                  />
                }
              />
            ) : (
              "Order Now"
            )}
          </button> */}
        </div>
      </form>
      <Drawer
        className="order_sent_drawer"
        placement={"bottom"}
        closable={true}
        onClose={() => setNotApproveIsVisible(false)}
        visible={notApproveIsVisible}
        key={"bottom"}
      >
        <div className="my-2">
          <h1>Saved!</h1>
          <p>Your customized product have been saved in your collection</p>
        </div>
        <img src={order_sent} alt="order sent" className="img-fluid my-2" />
      </Drawer>
      {/* {drawers.openBottom && (
        <BottomDrawer
          mode={"add_to_collection"}
          addCustomizedProduct
          customizedOrder={{
            ...data,
            product_id:
              params.status === "new"
                ? selectedProduct.id
                : selectedProduct.product_id,
          }}
        />
      )} */}
    </div>
  );
};

export { Product3dConfigTabs };
